module.exports = __webpack_public_path__ + "static/sportovni-odpoledne-na-czu-06-0edce21391fa2b6666c69e2053d89961.jpg";